import {FormattedMessage} from 'react-intl'

export const roleOptions = [
  {label: <FormattedMessage id='MENU.ADMINISTRATION' />, value: '2'},
  {label: <FormattedMessage id='MENU.TEACHER' />, value: '3'},
  {label: <FormattedMessage id='MENU.STUDENT' />, value: '4'},
  {label: <FormattedMessage id='MENU.PARENT' />, value: '5'},
  {label: <FormattedMessage id='ROLE.FINANCE_MANAGER' />, value: '6'},
  {label: <FormattedMessage id='ROLE.STOCK' />, value: '7'},
  {label: <FormattedMessage id='ROLE.LIMITED_STUDENT' />, value: '8'},
]

export const governorateOptions = [
  {label: <FormattedMessage id='MENU.ARIANA' />, value: 'Ariana'},
  {label: <FormattedMessage id='MENU.BEJA' />, value: 'Béja'},
  {label: <FormattedMessage id='MENU.BEN_AROUS' />, value: 'Ben Arous'},
  {label: <FormattedMessage id='MENU.BIZERTE' />, value: 'Bizerte'},
  {label: <FormattedMessage id='MENU.GABES' />, value: 'Gabès'},
  {label: <FormattedMessage id='MENU.GAFSA' />, value: 'Gafsa'},
  {label: <FormattedMessage id='MENU.JENDOUBA' />, value: 'Jendouba'},
  {label: <FormattedMessage id='MENU.KAIROUAN' />, value: 'Kairouan'},
  {label: <FormattedMessage id='MENU.KASSERINE' />, value: 'Kasserine'},
  {label: <FormattedMessage id='MENU.KEBILI' />, value: 'Kébili'},
  {label: <FormattedMessage id='MENU.KEF' />, value: 'Kef'},
  {label: <FormattedMessage id='MENU.MAHDIA' />, value: 'Mahdia'},
  {label: <FormattedMessage id='MENU.MANOUBA' />, value: 'Manouba'},
  {label: <FormattedMessage id='MENU.MEDENINE' />, value: 'Médenine'},
  {label: <FormattedMessage id='MENU.MONASTIR' />, value: 'Monastir'},
  {label: <FormattedMessage id='MENU.NABEUL' />, value: 'Nabeul'},
  {label: <FormattedMessage id='MENU.SFAX' />, value: 'Sfax'},
  {label: <FormattedMessage id='MENU.SIDI_BOUZID' />, value: 'Sidi Bouzid'},
  {label: <FormattedMessage id='MENU.SILIANA' />, value: 'Siliana'},
  {label: <FormattedMessage id='MENU.SOUSSE' />, value: 'Sousse'},
  {label: <FormattedMessage id='MENU.TATAOUINE' />, value: 'Tataouine'},
  {label: <FormattedMessage id='MENU.TOZEUR' />, value: 'Tozeur'},
  {label: <FormattedMessage id='MENU.TUNIS' />, value: 'Tunis'},
  {label: <FormattedMessage id='MENU.ZAGHOUAN' />, value: 'Zaghouan'},
]
